import { ReactNode, useEffect, useRef } from 'react';
import Lenis from 'lenis';
import { useLocation } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// تعریف تایپ برای children (اختیاری ولی توصیه می‌شود)
export default function SmoothScroll({ children }) {
  const lenis = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    // 1. ثبت پلاگین ScrollTrigger در GSAP
    gsap.registerPlugin(ScrollTrigger);

    // اگر نمونه‌ای از قبل وجود دارد، آن را از بین ببر
    if (lenis.current) {
      lenis.current.destroy();
    }

    // 2. ایجاد یک نمونه جدید از Lenis
    lenis.current = new Lenis({
      lerp: 0.1,
      smoothWheel: true,
    });

    // 3. همگام‌سازی Lenis با ScrollTrigger
    // هر بار که Lenis اسکرول می‌کند، ScrollTrigger را آپدیت کن
    lenis.current.on('scroll', ScrollTrigger.update);

    // 4. استفاده از gsap.ticker به جای requestAnimationFrame
    // این کار باعث می‌شود Lenis و GSAP در یک حلقه انیمیشن مشترک اجرا شوند
    gsap.ticker.add((time) => {
      // زمان را در ۱۰۰۰ ضرب می‌کنیم تا به میلی‌ثانیه تبدیل شود (Lenis اینطور نیاز دارد)
      lenis.current?.raf(time * 1000);
    });

    // 5. غیرفعال کردن lagSmoothing برای هماهنگی بهتر
    gsap.ticker.lagSmoothing(0);
    
    // 6. اسکرول به بالای صفحه در هر تغییر مسیر
    lenis.current.scrollTo(0, { immediate: true });

    // تابع پاک‌سازی (Cleanup)
    return () => {
      // هنگام خروج از کامپوننت یا تغییر مسیر، نمونه Lenis را از بین ببر
      lenis.current?.destroy();
      // نیازی به پاک کردن gsap.ticker نیست، زیرا با از بین رفتن نمونه، فراخوانی raf نیز متوقف می‌شود.
    };
  }, [pathname]); // این افکت با هر بار تغییر مسیر دوباره اجرا می‌شود

  return <>{children}</>;
}